import $ from "jquery";
import React, {createRef} from "react";
import {FaCrosshairs} from "react-icons/fa6";

import CheckBox from "@/legacy/form/CheckBox.jsx";
import SelectBox from "@/legacy/form/SelectBox.jsx";
import ShowPassword from "@/legacy/form/ShowPassword.jsx";
import TextArea from "@/legacy/form/TextArea.jsx";
import TextInput from "@/legacy/form/TextInput.jsx";
import URLInput from "@/legacy/form/URLInput.jsx";
import totp from "@/legacy/totp.js";
import HTMLElementListInput from "@/legacy/transaction/transaction_script_editor/HTMLElementListInput.jsx";
import TransactionUtils from "@/legacy/transaction/TransactionUtils.jsx";
import Utils from "@/legacy/Utils.js";

const MULTIPART_CONTENT_TYPES = ["multipart/form-data"];
const MULTIPART_FIELD_TYPES = ["form", "files"];

export default class EditStepForm extends React.Component {
  TextInput;

  constructor(props) {
    super(props);
    Utils.autoBindClass(this);
    this.selectingField = null;
    this.formContainer = createRef();
  }

  componentDidMount() {
    var elem = $(this.formContainer.current).find("input, select, textarea").first();
    if (elem.length && !elem.val()) {
      elem.focus();
    }
  }

  handleFieldChange(e, action) {
    const isSelect = action?.action === "select-option";
    const isCheckbox = e.target?.type === "checkbox";
    const name = isSelect ? action.name : e.target.name;
    const value = isSelect ? e.value : isCheckbox ? e.target.checked : e.target.value;
    this.props.onUpdateSelectedStepField(name, value);
  }

  render() {
    return (
      <div ref={this.formContainer} className="tab-content bordered">
        {this.renderFields()}
      </div>
    );
  }

  handleSelectElementClick(e, field) {
    this.selectingField = field;
    this.props.onSelectElement(this.props.step, field, this.props.onSelectElementCompleted);
  }

  handleOpenURLClick(e, field) {
    this.props.onOpenURL(this.props.step.values[field.name]);
  }

  handleGenerateOTPClick(e) {
    e.preventDefault();
    const secret = this.props.step.values.totp_secret,
      digits = parseInt(this.props.step.values.totp_digits) || 6,
      period = parseInt(this.props.step.values.totp_period) || 30;
    try {
      let otp = totp(secret, period, digits);
      //insert space after every 3 digits
      otp.code = otp.code.replace(/(.{3})/g, "$1 ").trim();
      Utils.copyToClipboard(
        otp.code,
        "Copy OTP to clipboard: Ctrl+c, Enter. Expires in " + otp.expires_in + " seconds."
      );
    } catch (e) {
      window.alert("Error generating OTP. Check the secret and try again.");
      console.error("OTP error", e);
    }
  }

  renderFields() {
    let currentGroup = null;
    return this.props.step.fields.map((field, idx) => {
      // Based on Content type hide or show the data or form elements
      if (MULTIPART_CONTENT_TYPES.includes(this.props.step.values["content_type"]) && field.name == "data") {
        this.props.step.values["data"] = "";
        return;
      } else if (
        !MULTIPART_CONTENT_TYPES.includes(this.props.step.values["content_type"]) &&
        MULTIPART_FIELD_TYPES.includes(field.name)
      ) {
        this.props.step.values[field.name] = "";
        return;
      }

      // A feature flagged field stays visible while it holds a value, so a customer whose
      // access was revoked can see and clear it (the backend refuses to save it).
      if (
        field.feature_flag &&
        !this.props.enabledFeatureFlags.includes(field.feature_flag) &&
        !this.props.step.values[field.name]
      ) {
        return null;
      }

      let label = field.label;
      if (this.props.step.step_def == "C_SET_VARIABLE") {
        const var_type = this.props.step.values.type;
        if (field.name == "options") {
          if (var_type == "const") {
            label = "Value";
          } else if (var_type == "random") {
            label = "Specifier";
          } else if (var_type == "date") {
            label = "Format";
          } else if (var_type == "element") {
            label = "Element Selector";
          } else if (var_type == "attr") {
            label = "Element Selector";
          }
        }

        if (field.name == "options2") {
          if (var_type == "date") {
            label = "Adjustment in seconds (optional)";
          } else if (var_type == "attr") {
            label = "Attribute Name";
          } else {
            return null;
          }
        }

        if (field.name == "options3") {
          if (var_type == "date") {
            label = "Timezone (optional, default UTC)";
          } else {
            return null;
          }
        }
      }

      let element = React.createElement(this.elementForFieldType(this.props.step, field), {
        key: field.name,
        fieldName: field.name,
        labelText: label,
        titleText: field.title,
        isRequired: !field.optional,
        value: this.props.step.values[field.name],
        formErrors: this.props.step.errors,
        onChange: this.handleFieldChange,
        htmlElementList: this.props.htmlElementList,
        choices: field.choices,
        allowVariables: field.type == "URL" ? true : null,
        inputType: field.type == "NUMBER" ? "number" : "text",
      });

      let groupHeader = null;
      if (field.field_group && field.field_group !== currentGroup) {
        groupHeader = (
          <div
            key={`group-${field.field_group}`}
            className="mt-3 mb-2"
            style={{borderTop: "1px solid #dee2e6", paddingTop: "8px"}}
          >
            <strong>{field.field_group}</strong>
          </div>
        );
      }
      currentGroup = field.field_group || null;

      if (element.type === CheckBox) {
        return (
          <React.Fragment key={`field-${idx}`}>
            {groupHeader}
            <div className="form-group">
              <div key={field.name + "-wrapper"}>{element}</div>
            </div>
          </React.Fragment>
        );
      } else {
        if (field.name === "totp_secret") {
          element = React.createElement(TextInput, {
            key: field.name,
            fieldName: field.name,
            labelText: label,
            titleText: field.title,
            isRequired: !field.optional,
            value: this.props.step.values[field.name],
            formErrors: this.props.step.errors,
            onChange: this.handleFieldChange,
            addonLabel: "Get Code",
            onAddonClick: (e) => this.handleGenerateOTPClick(e, field),
            httpsOnly: true,
            allowVariables: true,
          });
        } else if (this.props.onOpenURL && field.type === "URL") {
          element = React.createElement(URLInput, {
            key: field.name,
            fieldName: field.name,
            labelText: label,
            titleText: field.title,
            isRequired: !field.optional,
            value: this.props.step.values[field.name],
            formErrors: this.props.step.errors,
            onChange: this.handleFieldChange,
            addonLabel: "Go",
            onAddonClick: (e) => this.handleOpenURLClick(e, field),
            httpsOnly: true,
            allowVariables: true,
          });
        } else if (this.props.onSelectElement && field.type === "SELECTOR") {
          element = React.createElement(TextInput, {
            key: field.name,
            fieldName: field.name,
            labelText: label,
            titleText: field.title,
            isRequired: !field.optional,
            value: this.props.step.values[field.name],
            formErrors: this.props.step.errors,
            onChange: this.handleFieldChange,
            addonLabel: (
              <React.Fragment>
                <FaCrosshairs className="me-1" /> Select on page
              </React.Fragment>
            ),
            onAddonClick: (e) => this.handleSelectElementClick(e, field),
          });
        }
        return (
          <React.Fragment key={`field-${idx}`}>
            {groupHeader}
            <div className="form-group">{element}</div>
          </React.Fragment>
        );
      }
    });
  }

  elementForFieldType(step, field) {
    if (TransactionUtils.isSecretTextField(step, field)) {
      return ShowPassword;
    }

    switch (field.type) {
      case "URL":
        return URLInput;
      case "SELECTOR":
        return HTMLElementListInput;
      case "KEY_VALUE":
        return TextArea;
      case "REGEX":
        return TextInput;
      case "VARIABLE":
        return TextInput;
      case "TEXTINPUT":
      case "NUMBER":
        return TextInput;
      case "PASSWORD":
        return ShowPassword;
      case "TEXTAREA":
        return TextArea;
      case "BOOLEAN":
        return CheckBox;
      case "CHOICE":
        return SelectBox;
      default:
        return () => React.Fragment;
    }
  }
}

EditStepForm.defaultProps = {
  step: {},
  htmlElementList: null,
  enabledFeatureFlags: [],
};
